import { IntegrationAppLiterals } from '@trukt/types/Integration';
import { BaseRequest } from '@trukt/types/BaseRequest';
import { AxiosInstance } from 'axios';

export type InvoiceBulkReleaseRequest = {
  invoices: string[];
};

export type InvoiceBulkReleaseResponse = void;

export type InvoiceBulkExportRequestBody = {
  invoices: string[];
  apps?: IntegrationAppLiterals[];
};

export type InvoiceBulkExportRequestQueryParams = {
  force?: boolean;
  reset?: boolean;
};

export type InvoiceBulkExportRequest = BaseRequest<
  InvoiceBulkExportRequestQueryParams,
  InvoiceBulkExportRequestBody
>;

export type InvoiceBulkExportResponse = void;

export class InvoiceBulkService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  release(request: InvoiceBulkReleaseRequest) {
    return this.instance.put<InvoiceBulkReleaseResponse>('/bulk/invoices/payment-release', request);
  }

  export(request: InvoiceBulkExportRequest) {
    return this.instance.put<InvoiceBulkExportResponse>('/bulk/invoices/export', request.body, {
      params: request.queryParams,
    });
  }
}
